import { useRef, useState, useCallback } from "react";
import { MoveHorizontal } from "lucide-react";

export const BeforeAfter = ({ before, after, beforeLabel = "Avant", afterLabel = "Après", hint, alt = "" }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(55);
  const dragging = useRef(false);

  const setFromX = useCallback((clientX) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    let pct = ((clientX - rect.left) / rect.width) * 100;
    pct = Math.max(0, Math.min(100, pct));
    setPos(pct);
  }, []);

  return (
    <div
      ref={ref}
      data-testid="before-after"
      className="relative w-full overflow-hidden select-none cursor-ew-resize aspect-[3/2] group"
      onMouseMove={(e) => setFromX(e.clientX)}
      onMouseDown={(e) => { dragging.current = true; setFromX(e.clientX); }}
      onMouseUp={() => { dragging.current = false; }}
      onTouchStart={(e) => setFromX(e.touches[0].clientX)}
      onTouchMove={(e) => setFromX(e.touches[0].clientX)}
    >
      <img src={after} alt={alt} draggable={false} className="absolute inset-0 w-full h-full object-cover pointer-events-none" />
      <span data-testid="ba-after-label" className="absolute top-4 right-4 z-20 text-[11px] uppercase tracking-[0.2em] bg-black/40 text-white px-3 py-1 backdrop-blur-sm pointer-events-none">{afterLabel}</span>

      <img
        src={before}
        alt={alt}
        draggable={false}
        className="absolute inset-0 w-full h-full object-cover pointer-events-none"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
      />
      <span data-testid="ba-before-label" className="absolute top-4 left-4 z-20 text-[11px] uppercase tracking-[0.2em] bg-black/40 text-white px-3 py-1 backdrop-blur-sm pointer-events-none" style={{ opacity: pos > 14 ? 1 : 0 }}>{beforeLabel}</span>

      <div className="absolute top-0 bottom-0 z-10 w-[2px] bg-white/90 pointer-events-none" style={{ left: `${pos}%`, transform: "translateX(-1px)" }}>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white shadow-xl flex items-center justify-center">
          <MoveHorizontal size={18} className="text-olime-ink" />
        </div>
      </div>

      {hint && (
        <span className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 text-[11px] uppercase tracking-[0.2em] text-white/90 pointer-events-none transition-opacity duration-500 group-hover:opacity-0">{hint}</span>
      )}
    </div>
  );
};
